var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"documentationContainer"},[_c('h1',{staticClass:"documentationContainer__title large-title"},[_vm._v("\n    "+_vm._s(_vm.title)+"\n  ")]),_vm._t("content")],2)}
var staticRenderFns = []

export { render, staticRenderFns }